module.exports = new __parcel__URL__("deployment-frequency-welcome.4b7bb70b.svg").toString();